import type { FeedbackPost } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const feedbackPost = (data: FeedbackPost) => coreRequestService({
    url: '/feedback',
    method: 'POST',
    data
});
